export default {
  button_bar: {
    docx_button: {
      label: "Download i Word"
    },
    error: "Nogle felter mangler at blive udfyldt.",
    print_button: {
      label: "Print/gem som PDF"
    }
  },
  form: {
    contract_details: {
      headline: "Kontraktdetailjer",
      agreement_date: {
        label: "Aftaledato",
        placeholder: "Dato for indgåelse af aftale"
      },
      contract_type: {
        label: "Kontrakttype",
        distributor_label: "Distributør",
        supplier_label: "Leverandør"
      }
    },
    distributor_rights_and_obligations: {
      legend: "Distributørens rettigheder og forpligtigelser",
      marketing_percent: {
        label: "Markedsføringsprocent",
        placeholder: "Sats for markedsføringsforpligtigelse i %"
      },
      number_of_fairs: {
        label: "Antal af årlige messer",
        placeholder: "Indtast antal af årlige messer"
      },
      should_participate_in_fairs: {
        label: "Skal distributøren deltage i årlige messer?"
      }
    },
    duration_and_resignation: {
      duration: {
        label: "Løbetidstype",
        options: {
          limited_auto_renew: "Fast periode med automatisk fornyelse",
          unlimited: "Tidsubegrænset"
        }
      },
      earliest_resignation: {
        label: "Tidligst opsigelse",
        placeholder: "Dato for tidligst mulig opsigelse"
      },
      from_date: {
        label: "Fra dato",
        placeholder: "Dato for aftalens start"
      },
      to_date: {
        label: "Til dato",
        placeholder: "Dato for aftalens udløb"
      },
      period: {
        label: "Periodens længde",
        placeholder: "F.eks. 4 måneder"
      },
      legend: "Aftalens løbetid og opsigelse"
    },
    goodwill: {
      legend: "Godtgørelse for goodwill",
      goodwill_percent: {
        label: "Godtgørelse for goodwill i procent",
        placeholder: "Angiv procentsats for goodwill"
      }
    },
    other_regulations: {
      legend: "Andre bestemmelser og særlige tilføjelser",
      other_regulations_input: {
        label: "Andre bestemmelser",
        placeholder: "Indtast bestemmelse",
        add_button_label: "Tilføj bestemmelse"
      }
    },
    parties: {
      distributor: {
        address: {
          label: "Adresse",
          placeholder: "Distributørens adresse"
        },
        country: {
          label: "Land",
          placeholder: "Distributørens land"
        },
        cvr: {
          label: "CVR-nummer",
          placeholder: "Distributørens CVR-nummer"
        },
        headline: "Distributøren",
        name: {
          label: "Navn",
          placeholder: "Distributørens navn"
        },
        zip_city: {
          label: "Postnr. og by",
          placeholder: "Distributørens postnr. og by"
        }
      },
      supplier: {
        address: {
          label: "Adresse",
          placeholder: "Leverandørens adresse"
        },
        country: {
          label: "Land",
          placeholder: "Leverandørens land"
        },
        cvr: {
          label: "CVR-nummer",
          placeholder: "Leverandørens CVR-nummer"
        },
        headline: "Leverandøren",
        name: {
          label: "Navn",
          placeholder: "Leverandørens navn"
        },
        zip_city: {
          label: "Postnr. og by",
          placeholder: "Leverandørens postnr. og by"
        }
      }
    },
    product_and_area: {
      areas: {
        label: "Området",
        placeholder: "Området"
      },
      legend: "Produkter og område",
      products: {
        add_button_label: "Tilføj produkt",
        label: "Produkter",
        placeholder: "Produktet"
      },
      exclusive_right: {
        label: "Har distributøren eneforhandlingsret?"
      }
    },
    shared: {
      cvr_error: "Indtast et gyldigt CVR-nummer",
      remove_button_label: "Fjern",
      validation_error: "Du mangler at udfylde dette felt"
    },
    signature: {
      legend: "Underskrift",
      date: {
        label: "Dato",
        placeholder: "Dato for underskrift"
      }
    },
    supplier_rights_and_obligations: {
      compensationPercentage: {
        label: "Kompensationssats for fjernelse af kunde",
        placeholder: "Indtast kompensationssats i %"
      },
      legend: "Leverandørens rettigheder og forpligtigelser"
    },
    venue_governing_law: {
      legend: "Lovvalg - værneting",
      eea_or_eu: {
        label: "Har din samarbejdspartner hjemting udenfor EU/EØS?"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/eneforhandler/translations/form/da_form.js